import { render, staticRenderFns } from "./CampaignPeriodControls.vue?vue&type=template&id=94fba7e4"
import script from "./CampaignPeriodControls.vue?vue&type=script&lang=js"
export * from "./CampaignPeriodControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports